import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

/*
 * 그룹을 바꾸기 전에 '무엇이 어떻게 되는지'를 한 줄로 보여준다 (#78).
 *
 * 숫자만 적으면 "3명 추가"가 지금 몇 명인지와 무관해 보인다. 바뀌기 전과 후를 나란히
 * 두면 되돌릴 수 없는 작업 앞에서 한 번 더 눈에 들어온다.
 */
const Wrap = styled(Box)({
  marginTop: '14px',
  border: '1px solid #E8ECEF',
  borderRadius: '10px',
  overflow: 'hidden',
});

const Row = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 92px 22px 92px',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 14px',
  borderBottom: '1px solid #F1F4F6',
  '&:last-of-type': { borderBottom: 'none' },
});

const Label = styled(Typography)({
  fontSize: '13px',
  color: '#4B5563',
  fontWeight: 600,
  textAlign: 'left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const Before = styled(Typography)({
  fontSize: '13px',
  color: '#9AA3AC',
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const Arrow = styled('span')({
  color: '#C4CBD2',
  fontSize: '13px',
  textAlign: 'center',
});

const After = styled(Typography, {
  shouldForwardProp: prop => prop !== 'tone',
})(({ tone }) => ({
  fontSize: '13.5px',
  fontWeight: 800,
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: tone === 'up' ? '#0F8A80' : tone === 'down' ? '#C2453A' : '#1F2937',
}));

/**
 * @param rows [{ label, before, after, tone }] — tone 은 'up' | 'down' | 없음.
 *   before/after 는 이미 사람이 읽는 문자열이어야 한다(숫자면 '12명').
 */
const GroupChangeSummary = ({ rows = [] }) => {
  const { t } = useTranslation();
  if (!rows.length) return null;
  return (
    <Wrap>
      {rows.map(row => (
        <Row key={row.label}>
          <Label title={row.label}>{t(row.label)}</Label>
          <Before title={String(row.before)}>{row.before}</Before>
          <Arrow>→</Arrow>
          <After tone={row.tone} title={String(row.after)}>{row.after}</After>
        </Row>
      ))}
    </Wrap>
  );
};

export default GroupChangeSummary;
